import Swiper, { Navigation, Pagination, Autoplay } from 'swiper'; // core version + navigation, pagination modules:

Swiper.use([Navigation, Pagination, Autoplay]); // configure Swiper to use modules

const swiper = new Swiper('.swiper-container', {

  // Optional parameters
  loop: true,
  autoplay: {
    delay: 6000,
  },

  // If we need pagination
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
})

$('.swiper-container').hover(function() {
  (this).swiper.autoplay.stop();
}, function() {
  (this).swiper.autoplay.start();
});

export default swiper
